import {
  PAYERS_RECEIVED,
  PAYER_PLANS_FETCHING,
  PAYER_PLANS_RECEIVED,
} from 'shared/actions/PayersActions';

import { updateWithinCollection } from 'utils/combineCollectionReducers';

const initialState = {
  items: [],
};

const payerElementReducer = (payer, action) => {
  switch (action.type) {
    case PAYER_PLANS_FETCHING:
      return Object.assign({}, payer, { fetchingPlans: true });
    case PAYER_PLANS_RECEIVED:
      return Object.assign({}, payer, {
        fetchingPlans: false,
        plans: action.plans,
      });
    default:
      return payer;
  }
};

export default function payers(state = initialState, action) {
  switch (action.type) {
    case PAYERS_RECEIVED:
      return Object.assign({}, state, {
        items: action.payers,
      });

    case PAYER_PLANS_FETCHING:
    case PAYER_PLANS_RECEIVED:
      return Object.assign({}, state, {
        items: updateWithinCollection(state.items, action, payerElementReducer, 'payerId'),
      });

    default:
      return state;
  }
}
